export const updateDatiModPagAssegno = (unDato, unActionType) => {
  return {
    type: unActionType,
    unDato,
  }
};